import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-99bc4f22"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "noData"
};
import { onMounted, ref } from "vue";
import { Doughnut } from "vue-chartjs";
import { PALETTE } from "./model";
import { Chart, ArcElement, Legend, Tooltip } from 'chart.js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PieChart',
    props: {
        data: {}
    },
    setup(__props) {
        Chart.register(ArcElement, Legend, Tooltip);
        Chart.defaults.font.size = 14;
        Chart.defaults.font.weight = 'bold';
        const props = __props;
        const chart = ref(null);
        onMounted(() => {
            chart.value = {
                data: {
                    labels: props.data.map((p) => p.label),
                    datasets: [
                        {
                            data: props.data.map((p) => p.value),
                            backgroundColor: PALETTE,
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: { display: true, position: 'bottom' }
                    }
                },
                style: {
                    position: 'relative',
                    'max-height': '35vh'
                }
            };
        });
        return (_ctx, _cache) => {
            return (_ctx.data.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No data for this period "))
                : (chart.value)
                    ? (_openBlock(), _createBlock(_unref(Doughnut), {
                        key: 1,
                        id: `chart-${Math.random()}`,
                        options: chart.value.options,
                        style: _normalizeStyle(chart.value.style),
                        data: chart.value.data
                    }, null, 8, ["id", "options", "style", "data"]))
                    : _createCommentVNode("", true);
        };
    }
});
